import { Flex } from 'antd';
import React from 'react';

import classes from './style/ScreenContainer.module.css';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IScreenContainerProps {
  children?: React.ReactNode;
}

const ScreenContainer: React.FunctionComponent<IScreenContainerProps> = (
  props
) => {
  // TOOLS

  // PROPS
  const { children } = props;

  // STATE

  // SELECTORS

  // VIEW
  return (
    <Flex vertical flex={1} className={classes.screenContainer}>
      {children}
    </Flex>
  );
};

export default ScreenContainer;
